import { Col, Row } from 'antd'
import { MemberProps } from 'app/components/Core/convention'
import Actions from 'app/components/Core/Rental/Actions'
import KLink from 'app/components/Modules/KLink'
import Alert from 'app/components/UI-Elements/Feedback/Alert'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import { Routes } from 'app/routes/Routes'
import * as React from 'react'

const StatusInfo: React.FC<MemberProps<IRental>> = ({ member }) => {
  const { tRecordType } = ToolBox.useString()

  return (
    <Row gutter={[0, 12]}>
      <Col span={24}>
        <Alert
          showIcon={true}
          type={member.status_info.type}
          message={
            <KLink to={Routes.Rental.member(member.id.toString()).show}>
              <b>
                {member.status_info.title} - {tRecordType(RecordType.rental)} {member.rental_code}
              </b>
            </KLink>
          }
          description={
            <Row align="middle" justify="space-between" gutter={[12, 12]}>
              <KCol>
                <span dangerouslySetInnerHTML={{ __html: member.status_info.description }} />
              </KCol>
              <If condition={member.status_info.actions?.length}>
                <KCol>
                  <Actions member={member} />
                </KCol>
              </If>
            </Row>
          }
        />
      </Col>
    </Row>
  )
}

export default StatusInfo
